import React from 'react'

function Checkmark ({ className, fill, style }) {
  return (
    <svg fill={fill} className={className} style={style} width='14.052' height='10.5' viewBox='0 0 14.052 10.5'>
      <path d='M6.2,10.168,2.176,5.757l.479-.479L6.2,9.218l9.05-9.05.475.475Zm0,0' transform='translate(-1.926 0.082)' fill='currentColor' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='0.5' />
    </svg>
  )
}

Checkmark.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor',
  style: null
}

export default Checkmark
